// 表格
import javaService from "../../utils/request"

function handel(data) {
    var params = new URLSearchParams()
    for (const key in data) {
        params.append(key, data[key])
    }
    return params
}

export function calculategetPetroleumProportion() {
    return javaService({
        url: '/petroleumProportion/getPetroleumProportion',
        method: 'GET'
    })
}

export function calculatescaleCalculation(dataId, target) {
    return javaService({
        url: '/scaleCalculation/calculation/' + dataId + '/' + target,
        method: 'GET',
        isLoading: true
    })
}

export function calculateSave(data) {
    return javaService({
        url: '/scaleCalculation/save',
        method: 'post',
        data: handel(data),
        isLoading: true
    })
}

export function calculategetByCondition(data) {
    return javaService({
        url: '/scaleCalculation/getByCondition',
        method: 'GET',
        params: data
    })
}

export function calculategetByScaleCalculationId(data) {
    return javaService({
        url: '/scaleCalculation/getByScaleCalculationId',
        method: 'GET',
        params: data
    })
}